"use client";
import parse from "html-react-parser";
import Button from "../Buttons/Button";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useMediaQuery } from "@react-hook/media-query";
import { swiperClass } from "@/styles/cva/home.cva";

interface ExternalItem {
  title: string;
  btnText: string;
  link: string;
  bgImage?: string;
}

export function ExternalSection({ external }: { external: ExternalItem[] }) {
  const IS_MOBILE_VIEW = useMediaQuery("(max-width: 1000px)");

  return IS_MOBILE_VIEW ? (
    <div className="inline min-h-[200px]">
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{
          delay: 5000, // Auto slide every 5 seconds
          disableOnInteraction: false, // Keeps autoplay working even after user interaction
        }}
        pagination={{
          clickable: true,
        }}
        loop={true}
        className={swiperClass()}
      >
        {external?.map((item, index) => (
          <SwiperSlide key={index} >
            <div
              className="flex flex-col gap-y-4 p-8 rounded-lg bg-[#0f141a] w-full h-full relative overflow-hidden shadow-lg" 
            >
              <div
                className="absolute inset-0"
                style={{
                  backgroundImage: `url(${item.bgImage})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right center",
                  opacity: 0.8,
                }}
              />
              <div className="relative z-20 flex flex-col h-full">
                <div className="flex flex-col flex-grow justify-between gap-12">
                  <h2 className="font-poppins font-semibold text-neutral-light-50">
                    {parse(item.title)}
                  </h2>
                  <Button
                    href={item.link}
                    external={true}
                    text={item.btnText}
                    style="w-full lg:w-fit text-center bg-secondary-100 text-neutral-dark-50 hover:bg-[#049CA4]"
                  />
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>) : (
    <section className="hidden lg:grid grid-cols-1 lg:grid-cols-3 gap-x-6 gap-y-6 pb-14">
      {external?.map((item, index) => (
        <div
          key={index}
          className="flex flex-col gap-y-4 p-8 rounded-lg bg-[#0f141a] w-full relative overflow-hidden shadow-lg"
          style={{ minHeight: "300px" }}
        >
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `url(${item.bgImage})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right center",
              opacity: 0.8,
            }}
          />
          <div className="relative z-10 flex flex-col h-full">
            <h2 className="font-poppins font-semibold text-neutral-light-50 lg:text-3xl 2xl:text-[32px]">
              {parse(item.title)}
            </h2>
            <div className="flex-grow" />
            <Button
              href={item.link}
              external={true}
              text={item.btnText}
              style="w-fit bg-secondary-100 text-neutral-dark-50 hover:bg-[#049CA4]"
            />
          </div>
        </div>
      ))}
    </section>
  );
}
